export var NativeStreamClusterCurve;
(function (NativeStreamClusterCurve) {
    NativeStreamClusterCurve["NATIVE_STREAM_CLUSTER_CURVE_ZORDER"] = "zorder";
    NativeStreamClusterCurve["NATIVE_STREAM_CLUSTER_CURVE_HILBERT"] = "hilbert";
})(NativeStreamClusterCurve || (NativeStreamClusterCurve = {}));
